import { cloneDeep, merge } from 'lodash'

import { TaskStates, TaskTypes } from '@sigmasms/shared-types'

import { datePresets, getChosenMonth } from '@/utils'

import tasksTemplate from '@/components/services/tasks/template'
import { tasksFilter } from '@/components/services/tasks/utils'

import render from './render'

const defaultFilter = merge(
  cloneDeep(tasksFilter),
  { type: [ TaskTypes['payments:recurrent'], TaskTypes['billings:operations'] ] }
)

export default {
  name: 'Tasks',

  components: {
    'tasks-template': tasksTemplate({
      taskType: TaskTypes['billings:operations'],
      defaultFilter: cloneDeep(defaultFilter),
      presets: [
        {
          title: 'today',
          filter: merge(
            cloneDeep(defaultFilter),
            {
              state: undefined,
              createdAt: {
                $gt: undefined,
                $lt: undefined
              },
              createdAtPreset: datePresets.today
            }
          )
        },
        {
          title: 'twoWeeks',
          filter: Object.assign(
            cloneDeep(defaultFilter),
            {
              state: TaskStates.scheduled,
              createdAt: getChosenMonth(-1),
              createdAtPreset: undefined
            }
          )
        }
      ]
    })
  },

  render
}
